/**
 * Return hash parameters from url
 */
const getHashParams = () => {
  if (typeof window !== 'undefined') {
    for (
      var n,
        e = {},
        o = /\+/g,
        r = /([^&;=]+)=?([^&;]*)/g,
        t = function (n) {
          return decodeURIComponent(n.replace(o, ' '));
        },
        a = window.location.hash.substring(1);
      (n = r.exec(a));

    ) {
      e[t(n[1])] = t(n[2]);
    }
    return e;
  }
  return {};
};

/**
 * Allows the execution of SSR related logic in client side
 * IMPORTANT: There are conditions such as not having the window
 * variable that the simulation does not cover
 * @param {*} simulateSSR
 */
const isSimulateSSRModeActive = (simulateSSR) => {
  // eslint-disable-next-line no-use-before-define
  const urlParsedHash = getHashParams();
  // eslint-disable-next-line no-prototype-builtins
  if (simulateSSR || urlParsedHash.hasOwnProperty('simulateSSR')) {
    return true;
  }
  return false;
};

/**
 * Indicates when a content should be displayed in Server Side
 * @param {Date} simulateSSR
 */
const isSSR = (simulateSSR = false) => {
  // If you are in SSR always return data that can be analyzed by crawlers
  if (typeof window === 'undefined' || isSimulateSSRModeActive(simulateSSR)) {
    return true;
  }
  return false;
};

/**
 * It replaces the occurrence of a string is a text string.
 * @param {*} str Text string
 * @param {*} find Text substring to search
 * @param {*} replace Text string to replace
 */
const replaceAll = (str, find, replace) => {
  return str.replace(new RegExp(find, 'g'), replace);
};

export { isSSR, replaceAll, getHashParams };
